<div fxLayout="row" fxLayoutAlign="end end" class="header-dialog">
  <app-button type="icon" color="gray" [icon_fig]="Icons.CANCEL" (click)="onClose()" ></app-button>
</div>
<mat-dialog-content class="content" >
  <app-usuario></app-usuario>
</mat-dialog-content>
